export interface JobBrief {
  jobId: string
  appliance: string
  orderNumber: string
  address: string
  customer: string
  provider: string
  installer: string
  intake: { key: string; value: string }[]
  risk: { title: string; body: string; source: string }
  stageParts: string[]
  tools: string[]
  heroSrc: string
}

export const JOB: JobBrief = {
  jobId: 'JOB-52114',
  appliance: 'Hartley 6-Drawer Dresser — White Glove Delivery & Install',
  orderNumber: '664908',
  address: '4508 Maple Glen Court, Charlotte, NC 28210',
  customer: 'Elena Vasquez',
  provider: 'Premier Home Delivery',
  installer: 'Devon Carter',
  intake: [
    { key: 'Service tier', value: 'White glove — room of choice (upstairs nursery), anchor-to-wall included' },
    { key: 'Unit', value: '62"W × 34"H × 19"D, 145 lb boxed — 1 carton, drawers ship installed' },
    { key: 'Anchor kit', value: 'Bracket, strap, screws — ships taped inside the top drawer' },
    { key: 'Carry path', value: 'Stair landing measures 33" — carry upright, two-person turn' },
  ],
  risk: {
    title: 'Anchor-to-wall service on this order — anchor into a stud',
    body: 'This SKU class fails four known ways: corner crush in transit, drawer misalignment from carry-in racking, anchor kit never installed, and anchor screwed into drywall only. The kit ships taped inside the top drawer. The room of choice is a nursery — fasten the wall plate into a stud, keep the strap taut, and capture the connection before sliding the unit back flush; pushed back, a correct anchor is invisible. Furniture tip-overs send about 17,800 people to the ER each year; most fatalities are children.',
    source: 'Pre-visit flag (SKU pre-load + service addendum)',
  },
  stageParts: [
    'Anti-tip anchor kit (bracket, strap, 2 wood + 2 machine screws)',
    'Quilted floor runner',
    'Foam jamb protectors',
    'Touch-up pen (oak)',
  ],
  tools: [
    'Stud finder',
    'Cordless drill + #2 Phillips',
    'Torpedo level',
    'Furniture blankets',
    'Shoulder dolly straps',
  ],
  heroSrc: '/proof/hartley-dresser.jpg',
}
